<ion-app>
  <ion-header>
    <app-header></app-header>
  </ion-header>

  <ion-content class="content">
    <ion-router-outlet></ion-router-outlet>    
  </ion-content>
</ion-app>
